import { ReportTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import {
  AttachmentsScope,
  ImageDisplayStyle,
} from 'shared/domain/report/types/model/common';

const ATTACHMENTS_SCOPE_TOOLTIP_LABEL_KEYS: Record<
  AttachmentsScope,
  TranslationKey
> = {
  [AttachmentsScope.all]: ReportTranslationKeys.attachmentsScopeAllTooltip,
  [AttachmentsScope.main]: ReportTranslationKeys.attachmentsScopeMainTooltip,
};

const IMAGE_DISPLAY_STYLE_TOOLTIP_LABEL_KEYS: Record<
  ImageDisplayStyle,
  TranslationKey
> = {
  [ImageDisplayStyle.list]: ReportTranslationKeys.displayStyleListTooltip,
  [ImageDisplayStyle.miniatures]:
    ReportTranslationKeys.displayStyleMiniaturesTooltip,
  [ImageDisplayStyle.fullPage]: ReportTranslationKeys.displayStyleFullA4Tooltip,
};

export function attachmentsScopeTooltipLabelKey(
  scope: AttachmentsScope
): TranslationKey {
  return ATTACHMENTS_SCOPE_TOOLTIP_LABEL_KEYS[scope];
}

export function imageDisplayStyleTooltipLabelKey(
  style: ImageDisplayStyle
): TranslationKey {
  return IMAGE_DISPLAY_STYLE_TOOLTIP_LABEL_KEYS[style];
}
